import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./PartnersSection.css";

// Sample partner logos (replace with your own)
import logo1 from "../assets/logo-1.png";
import logo2 from "../assets/logo-2-1.png";
import logo3 from "../assets/logo-4.png";
import logo4 from "../assets/logo-44.png";
import logo5 from "../assets/logo-2-1.png";

const PartnersSection = () => {
  return (
    <section className="partners-section py-5">
      <Container>
        <Row>
          <Col md={12} className="text-center mb-4">
            <h2 className="fw-bold">Our Partners</h2>
          </Col>
          <Col md={12}>
            <div className="marquee">
              <div className="marquee-content">
                <img src={logo1} alt="Partner 1" />
                <img src={logo2} alt="Partner 2" />
                <img src={logo3} alt="Partner 3" />
                <img src={logo4} alt="Partner 4" />
                <img src={logo5} alt="Partner 5" />
                {/* Duplicate for infinite effect */}
                <img src={logo1} alt="Partner 1" />
                <img src={logo2} alt="Partner 2" />
                <img src={logo3} alt="Partner 3" />
                <img src={logo4} alt="Partner 4" />
                <img src={logo5} alt="Partner 5" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default PartnersSection;
